
import FormGroup from "./FormGroup"
import {useState, useEffect} from 'react';

const DateTimeSelector = (props) => {
    const [value, setValue] = useState(props.value)
    const onChange = (e) => {
        setValue(e.target.value)
        props.onChange(props.id, e.target.value);
    }

    useEffect(() => {
        if(props.onLoad) {
            props.onLoad();
        }
    },[])
    return (
        <FormGroup {...props}>
            <input className='form-control'
                   type="datetime-local"
                   name={props.id}
                   placeholder="DateRange"
                   value={value}
                   onChange={onChange}
            />
        </FormGroup>
    )
}

export default DateTimeSelector;